<template>
  <div id="cmg-simulator__print" class="print-only">
    <img v-if="brandFileName" :src="`/assets/brands/logos-original/${brandFileName}.svg`" style="width: 200px;" />
    <h3 class="mt-2">Informations de simulation</h3>
    <div class="row">
      <div class="col-6">
        <table class="table table-bordered font--xs">
          <tbody>
            <tr>
              <td>Situation employeur</td>
              <td>{{ situationFrench }}</td>
            </tr>
            <tr>
              <td>Enfants à charge</td>
              <td>{{ children }}</td>
            </tr>
            <tr>
              <td>Âge de l'enfant</td>
              <td>{{ childAgeFrench }}</td>
            </tr>
            <tr>
              <td>Ressources mensuelles moyennes (net imposable) {{ incomeReferenceYear }}</td>
              <td>{{ toMoney(averageMonthlySalaryParsed) }} (net) / mois</td>
            </tr>
            <tr>
              <td>Région</td>
              <td>{{ regionFrench }}</td>
            </tr>
            <tr>
              <td>Aides éventuelles hors CMG</td>
              <td>{{ otherAidToggle ? (otherAid + '€ / mois') : 'Non' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-6">
        <table class="table table-bordered font--xs">
          <tbody>
            <tr>
              <td>Nombre de semaines</td>
              <td>{{ yearlyWeeks }} semaines</td>
            </tr>
            <tr>
              <td>{{ isWeek ? 'Jours par semaine' : "Jours de garde mensualisés" }}</td>
              <td>{{ isWeek ? weeklyWorkedDays : monthlyWorkedDays }} jours</td>
            </tr>
            <tr>
              <td>{{ isWeek ? 'Heures par semaine' : "Heures de garde mensualisées" }}</td>
              <td>{{ isWeek ? weeklyHours : monthlyHours }} heures</td>
            </tr>
            <tr>
              <td>Heures maj. par {{ isWeek ? 'semaine' : 'mois' }}</td>
              <td>{{ isWeek ? toDecimal4(weeklyOvertimeFloat) : monthlyOvertime }} heures</td>
            </tr>
            <tr v-if="hasOvertime">
              <td>Heures maj.</td>
              <td>{{ increaseOvertime }}%</td>
            </tr>
            <tr>
              <td>Indemnités d'entretien</td>
              <td>{{ toMoney(maintenanceAllowanceFloat) }}</td>
            </tr>
            <tr>
              <td>Indemnités repas</td>
              <td>{{ toMoney(mealDailyAllowanceParsed) }}</td>
            </tr>
            <tr>
              <td>Taux horaire</td>
              <td>
                {{ toMoney(grossHourlyWageFloat) }} brut
                <i>(env. {{ toMoney(netHourlyWage) }} net)</i>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div v-if="isCalculable">
      <h3 class="mt-3">Détail du calcul de coût total</h3>
      <slot name="cost-details" />
      <h3 class="mt-3">Détail du calcul des aides</h3>
      <slot name="aids-details" />
    </div>

    <h3 class="mt-3">À propos de {{ brandName }}</h3>
    <p>
      <a :href="brandHost">{{ brandWebsite }}</a> est un service 100% spécialisé dans la gestion
      administrative des contrats d'assistant(e) maternel(le). Il permet aux employeurs et aux assistant(e)s
      maternel(le)s de gagner beaucoup de temps, de se simplifier la vie, et d'être en confiance pour toute
      la comptabilité.
    </p>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'PrintSection',
  props: {
    brandFileName: { type: String, default: '' },
    brandName: { type: String, default: '' },
    brandWebsite: { type: String, default: '' },
    brandHost: { type: String, default: '' },
    situationFrench: { type: String, default: '' },
    children: { type: String, default: '' },
    childAgeFrench: { type: String, default: '' },
    regionFrench: { type: String, default: '' },
    incomeReferenceYear: { type: Number, default: () => new Date().getFullYear() - 2 },
    averageMonthlySalaryParsed: { type: Number, default: 0 },
    otherAidToggle: { type: Boolean, default: false },
    otherAid: { type: String, default: '0' },
    yearlyWeeks: { type: String, default: '' },
    weeklyWorkedDays: { type: String, default: '' },
    weeklyHours: { type: String, default: '' },
    monthlyWorkedDays: { type: String, default: '' },
    monthlyHours: { type: String, default: '' },
    monthlyOvertime: { type: String, default: '0' },
    increaseOvertime: { type: String, default: '25' },
    hasOvertime: { type: Boolean, default: false },
    isWeek: { type: Boolean, default: false },
    isCalculable: { type: Boolean, default: false },
    weeklyOvertimeFloat: { type: Number, default: 0 },
    maintenanceAllowanceFloat: { type: Number, default: 0 },
    mealDailyAllowanceParsed: { type: Number, default: 0 },
    grossHourlyWageFloat: { type: Number, default: 0 },
    netHourlyWage: { type: Number, default: 0 },
    toMoney: { type: Function, required: true },
    toDecimal4: { type: Function, required: true },
  },
});
</script>
